import React, { useState, useEffect } from "react";
import "./styles/PacientesServicos.css";
import { FaCheck } from "react-icons/fa";
const PacientesServicos = () => {
  const [city, setCity] = useState("");
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [especialidades] = useState([
    "Clínica Geral",
    "Cardiologia",
    "Dermatologia",
    "Pediatria",
    "Ginecologia",
    "Ortopedia",
    "Oftalmologia",
  ]);
  const [cidadesProximas, setCidadesProximas] = useState([]);

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  useEffect(() => {
    checkAndShowServices();
  }, []);

  const checkAndShowServices = async () => {
    const storedData = localStorage.getItem("patientData");
    if (!storedData) {
      setMessage("Ops! Parece que seus dados não estão armazenados. Faça login novamente.");
      return;
    }

    const patientData = JSON.parse(storedData);
    if (patientData && patientData.cidade && patientData.cidade.trim() !== "") {
      setCity(patientData.cidade);
      await fetchServices(patientData.cidade);
      fetchCidadesProximas(patientData.cep); // usa o CEP agora
    } else {
      setMessage(
        `<strong>Ops!</strong> Parece que sua cidade ainda não está cadastrada.
        Por favor, vá até a aba <strong>Suas informações</strong> e preencha o nome da sua cidade 
        para que possamos mostrar os serviços disponíveis na sua região.`
      );
    }
  };

  const fetchServices = async (cityName) => {
    setLoading(true);
    setMessage("");
    setServices([]);

    try {
      const response = await fetch("https://x8ki-letl-twmt.n7.xano.io/api:1gyP90jK/negocios_por_area", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cidade: cityName }),
      });

      if (!response.ok) throw new Error(`Erro: ${response.status}`);

      let data = await response.json();

      if (selectedTags.length > 0) {
        data = data.filter((s) =>
          selectedTags.includes(s.tipo) || selectedTags.includes(s.cidade)
        );
      }

      if (data.length === 0) {
        setMessage(`Ops! Nenhum serviço encontrado com os filtros selecionados.`);
      } else {
        setServices(data);
      }
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
      setMessage("Erro! Não foi possível carregar os serviços.");
    } finally {
      setLoading(false);
    }
  };

  const fetchCidadesProximas = async (cep) => {
    try {
      const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${cep}`);
      if (!response.ok) return;
      const data = await response.json();
      if (data.city) {
        setCidadesProximas([
          data.city,
          "Cidade A",
          "Cidade B",
          "Cidade C",
        ]);
      }
    } catch (error) {
      console.error("Erro ao buscar cidades próximas:", error);
    }
  };

  return (
    <div className="pacientes-servicos">
      <h2>Serviços da sua região</h2>

      <div className="filter-grid">
        <div className="filter-col">
          <h4>Especialidades</h4>
          <div className="tag-container">
          {especialidades.map((item) => (
              <button
                key={item}
                className={`tag ${selectedTags.includes(item) ? "selected" : ""}`}
                onClick={() => toggleTag(item)}
              >
                {item}
                {selectedTags.includes(item) && (
                  <FaCheck style={{ marginLeft: 8, color: "white" }} />
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-col">
          <h4>Cidades próximas</h4>
          <div className="tag-container">
            {cidadesProximas.map((city) => (
              <button
                key={city}
                className={`tag ${selectedTags.includes(city) ? "selected" : ""}`}
                onClick={() => toggleTag(city)}
              >
                {city}
                {selectedTags.includes(city) && (
                  <FaCheck style={{ marginLeft: 8, color: "white" }} />
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {loading && <p>Carregando serviços...</p>}

      {message && (
        <div
          className="cidade-warning"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}

      {services.length > 0 && !loading && (
        <div className="services-container">
          {services.map((service) => (
            <div className="service-item" key={service.id}>
              <h3>{service.nome}</h3>
              <p><strong>Descrição:</strong> {service.descricao || "Não informado"}</p>
              <p><strong>Endereço:</strong> {service.endereco || "Não informado"}</p>
              <p><strong>Telefone:</strong> {service.telefone || "Não informado"}</p>
              <p><strong>CEP:</strong> {service.CEP || "Não informado"}</p>
              <p><strong>Cidade:</strong> {service.cidade}</p>
              <p><strong>Avaliação:</strong> {service.rating}</p>
              {service.photo && (
                <img src={service.photo} alt={service.nome} style={{ maxWidth: "100%", height: "auto" }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PacientesServicos;